import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { Analytics } from '@vercel/analytics/react';

import Header from './components/layout/Header';
import Footer from './components/layout/Footer';

import Home from './pages/Home';
import About from './pages/About';
import News from './pages/News';
import Contact from './pages/Contact';
import Programs from './pages/Programs';
import Chapters from './pages/Chapters';
import Numbers from './pages/Numbers';
import Partnerships from './pages/Partnerships';
import CanvaSlideshow from './pages/AnnualReport';
import Tools from './pages/Tools';

import Rochester from './pages/chapters/Rochester';
import Cornell from './pages/chapters/Cornell';
import UChicago from './pages/chapters/UChicago';
import ComingSoon from './pages/ComingSoon';

// Code-split the data tools so their charting/data code (recharts, etc.) loads
// only when the route is visited, keeping the main bundle small on mobile.
const CollegeTools = lazy(() => import('./pages/CollegeTools'));
const MajorMobilityExplorer = lazy(() => import('./pages/MajorMobilityExplorer'));
const ScholarshipOpportunities = lazy(() => import('./pages/ScholarshipOpportunities'));

function App() {
  return (
    <Router>
      <SpeedInsights />
      <Analytics />
      <Header />
      <main className="page-content">
      <Suspense fallback={<div className="mx-auto max-w-6xl px-4 py-10 text-muted-foreground">Loading…</div>}>
      <Routes>
        {/* Main pages */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/news" element={<News />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/programs" element={<Programs />} />
        <Route path="/chapters" element={<Chapters />} />
        <Route path="/statistics" element={<Numbers />} />
        <Route path="/partnerships" element={<Partnerships />} />
        <Route path="/annualreport24" element={<CanvaSlideshow />} />
        <Route path="/tools" element={<Tools />} />
        <Route path="/college-tools" element={<CollegeTools />} />
        <Route path="/major-mobility-explorer" element={<MajorMobilityExplorer />} />
        <Route path="/scholarship-opportunities" element={<ScholarshipOpportunities />} />

        {/* Active chapter pages */}
        <Route path="/rochester" element={<Rochester />} />
        <Route path="/cornell" element={<Cornell />} />
        <Route path="/uchicago" element={<UChicago />} />

        {/* Chapters launching soon */}
        <Route path="/jhu" element={<ComingSoon />} />
        <Route path="/princeton" element={<ComingSoon />} />
        <Route path="/columbia" element={<ComingSoon />} />
        <Route path="/upenn" element={<ComingSoon />} />
        <Route path="/tufts" element={<ComingSoon />} />
        <Route path="/usf" element={<ComingSoon />} />
      </Routes>
      </Suspense>
      </main>
      <Footer />
    </Router>
  );
}

export default App;
